import Asset from "@components/CustomTypography/Asset/Asset"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Overlay from "@components/CustomTypography/Overlay/Overlay"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {HeroModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

import ContainerWrapper from "../Wrappers/ContainerWrapper/ContainerWrapper"

import styles from "./FullWidthHeaderAdvanced.module.scss"
import ImageBackground from "./ImageBackground"
import VideoBackground from "./VideoBackground"

const FullWidthHeaderAdvanced = (props: {
	data: HeroModuleType
	className?: string
	textColor?: "black" | "white"
	withOverlay?: boolean
	popupType?: "content" | "asset" | "default"
	titleWithoutHtml?: boolean
	titleStyle?: string
	contrast?: boolean
	subtitleStyle?: string
	opacityNumber?: string
	overlayColor?: string
}) => {
	const type = props.data.desktopAsset?.type || "none"

	const typeClass = styles[type]

	const contentClass = `${styles.video__content} ${typeClass}`
	const buttonsClass = `${styles.video__content_buttons}`

	const background = type === "none" ? "#F8FAFE" : "transparent"

	return (
		<div style={{background}}>
			<div
				className={`${styles.backgroundVideo} ${typeClass} ${props.className}`}
			>
				<div className={styles.content__container}>
					<ContainerWrapper className={`${styles.contentBox} `}>
						<div
							className={contentClass}
							style={{color: props.textColor}}
						>
							<div className={styles.titleContainer}>
								<div className={styles.titleBox}>
									{props.data.beforeTitlesIcon && (
										<NewResponsiveImage
											containerClassName={`${styles.iconContainer}`}
											imageClassName={`${styles.icon} ${
												props.data.rightSideAsset
													?.filename
													? styles.disableIcon
													: ""
											}`}
											{...props.data.beforeTitlesIcon}
										/>
									)}
									<div>
										<Typography
											className={`${styles.title} ${props.titleStyle}`}
											content={props.data.title}
											contrast={props.contrast ?? true}
											size={Size.XXL}
											variant={Variant.Title}
											withoutHtml={props.titleWithoutHtml}
										/>
										<Typography
											className={`${styles.subtitle} ${props.subtitleStyle}`}
											content={props.data.subtitle}
											contrast={props.contrast ?? true}
											size={Size.XS}
											variant={Variant.Description}
										/>
										{props.data.buttons?.[0] && (
											<div className={buttonsClass}>
												<ButtonSwitcher
													buttonsList={props.data}
													popup={{
														type: props.popupType
															? props.popupType
															: "asset",
														data: props.data,
													}}
													withoutTarget
												/>
											</div>
										)}
									</div>
								</div>
								{props.data.rightSideAsset && (
									<Asset
										data={{
											...props.data.rightSideAsset,
											containerClassName:
												styles.rightImageContainer,
											imageClassName: styles.rightImage,
											alt:
												props?.data?.title ??
												props.data.rightSideAsset?.alt,
										}}
										type={props.data.rightSideAsset.type}
									/>
								)}
							</div>
						</div>
					</ContainerWrapper>
				</div>
				{type === "video" && props.data.desktopAsset && (
					<VideoBackground
						desktop={props.data.desktopAsset}
						mobile={props.data.mobileAsset}
					/>
				)}

				{type === "image" && props.data.desktopAsset && (
					<ImageBackground
						alt={props.data.title}
						desktop={props.data.desktopAsset}
						mobile={props.data.mobileAsset}
					/>
				)}
				{props.withOverlay && (
					<Overlay
						color={props.overlayColor}
						opacity={props?.opacityNumber ?? "0.4"}
					/>
				)}
			</div>
		</div>
	)
}

export default FullWidthHeaderAdvanced
